module.exports = __webpack_public_path__ + "static/img/Ajustados sin fondo_descargar_dis.9efd9529.svg";